import {
  DRUG_LOADING,
  DRUG_SUCCESS,
  DRUG_FAILED,
} from "../Constants/drugConstants";

import {
  DRUG_SAVE_LOADING,
  DRUG_SAVE_SUCCESS,
  DRUG_SAVE_FAILED,
} from "../Constants/drugConstants";

export const drugReducer = (
  state = { drugData: [] },
  action
) => {
  switch (action.type) {
    case DRUG_LOADING:
      return { loading: true, drugData: [] };
    case DRUG_SUCCESS:
      return { loading: false, drugData: action.payload };
    case DRUG_FAILED:
      return { loading: false, error: action.drugData };
    default:
      return state;
  }
};

export const drugSaveReducer = (
  state = { drugSaveData: [] },
  action
) => {
  switch (action.type) {
    case DRUG_SAVE_LOADING:
      return { loading: true, drugSaveData: [] };
    case DRUG_SAVE_SUCCESS:
      return { loading: false, drugSaveData: action.payload };
    case DRUG_SAVE_FAILED:
      return { loading: false, error: action.drugSaveData };
    default:
      return state;
  }
};
